import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UserLayout from '@components/layout/UserLayout.tsx';
import RequisitionsList from '@features/client/requisitions/RequisitionsList.tsx';
import { RequisitionStatus } from '@api/generated/search-service';
import { PermissionTypesEnum } from '@mock/Permissions.ts';

const requisitionSearchSchema = z.object({
  query: z.string().optional(),
  status: z.nativeEnum(RequisitionStatus).optional(),
  page: z.coerce.number().optional().default(1),
});

export type RequisitionSearchParams = z.infer<typeof requisitionSearchSchema>;

export const Route = createFileRoute('/c/$orgId/$portalId/requisitions/')({
  validateSearch: search => requisitionSearchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();

  // Feature REQUISITIONS se tu nevyžaduje — řešitel v nadřízené organizaci ji sám mít nemusí,
  // zpracovává žádanky podřízených. Odeslání žádanky feature hlídá v košíku i na backendu.
  return (
    <UserLayout oneOfPermission={[PermissionTypesEnum.CLIENT_ORDER_CREATE_REQUISITION, PermissionTypesEnum.CLIENT_REQUISITION_PROCESS]}>
      <div className="max-w-[1200px] mx-auto">
        <RequisitionsList search={search} />
      </div>
    </UserLayout>
  );
}
